import api from "../index";
const getPlatformStats = (params) => {
  try {
    return api.get("/project/investment",{params});
  } catch (err) {
    console.log(err, "error=>");
  }
};
export { getPlatformStats };
